/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import baustein from "baustein";
import globalEvents from "../utils/global-events";

export default baustein.register("member-feature-count", {
    defaultOptions: {
        itemCount: 0,
    },
    init() {
        this.options.itemCount = parseInt(this.el.dataset["itemCount"], 10);
        globalEvents.on("member-feature-decrease-count", this.decreaseCount.bind(this));
    },
    increaseCount: function() {
        this.setCount(this.getCount() + 1);
    },
    decreaseCount: function() {
        this.setCount(this.getCount() - 1);
    },
    getCount: function() {
        return this.options.itemCount;
    },
    setCount: function(newValue) {
        this.options.itemCount = newValue;
        this.el.dataset["itemCount"] = newValue;
        this.el.innerHTML = `(${newValue})`;
    }
});

